<template>
  <v-flex style="display: flex;justify-content: center;">
    <v-flex v-if="upgradeDialog" class="xs12">
      <div>
        <v-card-title class="title primary pa-3 font-weight-light white--text" primary-title>
          <span v-text="showCoupons === true ? 'Select Coupon' : 'Upgrade License'" />
          <v-spacer></v-spacer>
          <span class="notranslate"><v-icon dark @click="goBack">clear</v-icon></span>
        </v-card-title>

        <v-card-text class="pb-0">
          <div class="d-inline flex justify-self-center">
            <v-layout v-if="licenseClientToken!== 0">
              <license-payment
                page="quick-payment"
                name="test1"
                :token="licenseClientToken"
                :paypal="true" :userId="user.id" orderId="SFHTier1"
                :memberId="group.memberId" :selectedCouponId="selectedCouponId" :amount="effectivePrice">
              </license-payment>
            </v-layout>
            <v-layout v-else row wrap align-center justify-center>
              <v-flex pa-2 xs12>Hello! Pay the license fee to complete the certificate program. You'll get all levels
                and features, as well as unlimited exam attempts. </v-flex>
              <v-flex pa-2 xs6 class="text-xs-center"><img style="height:100px;"
                                                           src="static/images/learn_and_play.png"></v-flex>
              <v-flex pa-2 xs6 class="text-xs-center"><a target="__blank"
                                                         href="https://www.cogneti.com/user-license">License details&hellip;</a></v-flex>
              <v-flex v-if="selectedCouponCode" px-2 py-0 xs12 class="green--text">
                Coupon <span class="font-weight-bold" v-text="selectedCouponCode" /> applied successfully!!
              </v-flex>
              <v-flex px-2 xs12>
                <v-btn color="success" :disabled="priceLoading" block @click="fetchBtToken">
                  Upgrade for
                  <span
                    style="text-decoration: line-through;"
                    v-if="selectedCouponCode">&nbsp;${{price}}</span>
                  &nbsp;<span class="subheading font-weight-bold">${{printPrice(effectivePrice)}}</span>
                </v-btn>
              </v-flex>

              <v-flex px-2 xs12 v-if="this.buyNow === false">
                <v-layout>
                  <v-flex xs12>
                    <v-text-field label="Coupon" clearable @click:clear="clearCoupon()" v-model="appliedCoupon">
                      <template v-slot:append>
                        <v-btn flat class="mr-0" :disabled="selectedCouponCode !== '' && appliedCoupon !== ''"
                               :loading="couponLoading" color="info" @click="validateCoupon">Apply
                          <template v-slot:loader>
                            Applying...
                          </template>
                        </v-btn>
                      </template>

                    </v-text-field>
                  </v-flex>
                </v-layout>

              </v-flex>

              <v-flex px-2 pb-4 class="text-xs-center" v-if="this.buyNow === false">
                <button
                  class="coupon-available"
                  @click="showCoupons = true"
                  style="text-decoration: underline">Check for your discount coupons</button>
              </v-flex>

              <v-flex px-2 pb-4 class="text-xs-center" v-if="this.buyNow">
                &nbsp;
              </v-flex>
            </v-layout>
          </div>

          <div v-if="showCoupons === true">

            <v-card :key="index" v-for="(coupon, index) in coupons">
              <v-card-title primary-title class="coupon green lighten-5">
                <v-flex>
                  <v-flex class="coupon coupon-hover green lighten-4" @click="selectCoupon(coupon)">
                    <span class="font-weight-bold" v-text="coupon.code"/>
                    <span class="notranslate"><v-icon  style="float:right;">content_copy</v-icon></span>
                  </v-flex>
                  <v-layout wrap class="py-2">
                    <v-flex xs4 text-xs-left>
                            <span class="title font-weight-medium"
                                  v-text="coupon.discount + '% OFF'"
                                  style="font-size:15px!important;" />
                    </v-flex>
                    <v-flex xs8 text-xs-right>
                      <span class="subheading font-weight-light">Price:</span>
                      <s>${{price}}</s> <span class="title font-weight-medium"
                                              v-text="'$'+printPrice(getDiscountedPrice(coupon.discount))"
                                              style="font-size:17px!important;" /></v-flex>
                  </v-layout>
                </v-flex>
              </v-card-title>
            </v-card>
            <v-flex v-if="!coupons.length">
              <p class="subheading red--text">
                No coupons are available!
              </p>
            </v-flex>
            <v-flex class="text-xs-left">
              <v-btn flat class="pl-0 ml-0" @click="showCoupons = false">
                <span class="notranslate"><v-icon>keyboard_backspace</v-icon></span> Back
              </v-btn>
            </v-flex>
          </div>
        </v-card-text>
      </div>
    </v-flex>
  </v-flex>
</template>

<script>

import LicensePayment from './widgets/LicensePayment.vue'
export default {
  name: 'UpgradeLicense',
  components: {
    LicensePayment
  },
  data () {
    return {
      apiUrl: process.env.API_URL,
      appId: process.env.GAME_ID,
      appName: process.env.APP_NAME,
      upgradeDialog: false,
      priceLoading: false,
      price: 0,
      effectivePrice: 0,
      appliedCoupon: '',
      selectedCouponId: null,
      selectedCouponCode: '',
      couponLoading: false,
      showCoupons: false,
      coupons: [],
      bestCoupon: null,
      buyNow: false
    }
  },
  computed: {
    user () {
      return this.$store.getters['user/getUserDetails']
    },
    group () {
      return this.$store.getters['course/getGroups'].find(group => group.groupId === this.groupId())
    },
    licenseClientToken () {
      return this.$store.getters['braintree/getClientToken']
    },
    transactionSuccessful: {
      get: function () {
        return this.$store.getters['braintree/getTransactionSuccessfulLicense']
      },
      set: function (status) {
        this.$store.commit('braintree/setTransactionSuccessfulLicense', status)
      }
    }
  },
  mounted: function () {
    this.openBuyNow()
    setTimeout(() => {
      this.couponByTag()
      this.getAvailableCoupons()
    }, 1000)
  },
  methods: {
    fetchBtToken () {
      this.$store.dispatch('braintree/purchaseLicense', this.user.id)
    },
    clearCoupon () {
      this.selectedCouponId = 0
      this.selectedCouponCode = ''
      this.appliedCoupon = ''
      this.effectivePrice = this.price
    },

    couponByTag () {
      this.$http({
        url: this.apiUrl + `/ws/userservice/coupons/course/${process.env.GAME_ID}?tags=ALL`,
        method: 'GET'
      }).then(res => {
        this.bestCoupon = res.data
      }).catch((e) => {
        console.log('Caught', e)
      })
    },
    validateCoupon () {
      const appliedCoupon = this.appliedCoupon
      if (!appliedCoupon) {
        this.$store.commit('flashError', 'Invalid coupon.', { root: true })
        return false
      }
      this.couponLoading = true
      this.$http({
        url: this.apiUrl + `/ws/checkout/coupon/${appliedCoupon}/user/${this.user.id}/course/${process.env.GAME_ID}`,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + this.$auth.token()
        }
      }).then(res => {
        this.selectedCouponId = res.data.couponId
        this.selectedCouponCode = res.data.code
        this.effectivePrice = this.getDiscountedPrice(res.data.discount)
        this.couponLoading = false
      }, () => {
        this.$store.commit('flashError', 'Invalid coupon.', { root: true })
        this.couponLoading = false
      }).catch((e) => {
        console.log('Caught', e)
      })
    },
    selectCoupon (coupon) {
      this.appliedCoupon = coupon.code
      this.selectedCouponId = coupon.couponId
      this.selectedCouponCode = coupon.code
      this.showCoupons = false
      this.effectivePrice = this.getDiscountedPrice(coupon.discount)
    },
    getAvailableCoupons () {
      this.$http({
        url: this.apiUrl + `/ws/checkout/coupons/user/${this.user.id}/course/${process.env.GAME_ID}`,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + this.$auth.token()
        }
      }).then((res) => {
        this.coupons = res.data
      }, (err) => {
        console.log('error found', err)
      }).catch((e) => {
        console.log('Caught', e)
      })
    },
    calculateDiscountedPrice (price, discount) {
      return parseFloat((price - ((price * discount) / 100)))
    },
    getDiscountedPrice (discount) {
      return parseFloat((this.price - ((this.price * discount) / 100)))
    },
    printPrice (price) {
      return price
      // return Number.isInteger(price) ? price : price.toFixed(2)
    },
    goBack () {
      this.$router.push({name: 'ProgramLevels', params: {deckId: this.deckId(), groupId: this.groupId()}})
    },
    openUpgradeDialog () {
      this.upgradeDialog = true
      this.showCoupons = false
    },
    openBuyNow () {
      this.upgradeDialog = true
      this.getCoursePrice()
    },
    getCoursePrice () {
      this.priceLoading = true
      this.$http({
        url: this.apiUrl + `/ws/playerservice/program/${this.appId}/cost`,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + this.$auth.token()
        }
      }).then((res) => {
        this.priceLoading = false
        this.clearCoupon()
        this.price = res.data.cost
        this.effectivePrice = res.data.cost
        if (this.buyNow) {
          this.selectCoupon(this.bestCoupon)
        }
        this.openUpgradeDialog()
      }, (err) => {
        console.log('error found', err)
      }).catch((e) => {
        console.log('Caught', e)
      })
    },
    groups: function () {
      return this.$store.getters['course/getGroups']
    },
    groupId () {
      return typeof this.$route.params.groupId !== 'undefined'
        ? parseInt(this.$route.params.groupId) : parseInt(this.groups[0].groupId)
    },
    deckId () {
      return typeof this.$route.params.deckId !== 'undefined'
        ? parseInt(this.$route.params.deckId) : parseInt(this.groups[0].decks[0].id)
    }
  },
  watch: {
    transactionSuccessful (newVal) {
      if (newVal === true) {
        this.goBack()
      }
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/UpgradeLicense.vue